/* @ngInject */
const displayMenu = (
  entities,
  valueHandler,
  labels
) => {
  const self = {}

  self.radio = {
    value: 'wagon',
  }

  self.items = {}

  const hasAtLeastOneOutput = (_fields) => {
    for (const fieldName in _fields) {
      if (_fields.hasOwnProperty(fieldName)) {
        const field = _fields[fieldName]
        if (valueHandler.isObject(field.output)) {
          return true
        }
      }
    }
    return false
  }

  for (const entityName in entities) {
    if (entities.hasOwnProperty(entityName)) {
      if (hasAtLeastOneOutput(entities[entityName].metadata.fields)) {
        const entityLabels = labels[entityName]
        if (valueHandler.isObject(entityLabels)) {
          const label = entityLabels.title
          if (valueHandler.isString(label)) {
            self.items[entityName] = {
              ref: entityName,
              label: label,
              go: () => {

              },
            }
          }
        }
      }
    }
  }

  return self
}

export default displayMenu



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/display/display.menu.js